import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
    conversationAI: [], // for context - sending to API.
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
    getConversationAI: (state) => state.conversationAI,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
    setConversationsAI(state, message) {
      state.conversationAI.push(message);
    },
    clearConversationsAI(state) {
      state.conversationAI = [];
    },
  },
  actions: {
    avatarTalk({ getters, commit }, speechText) {
      commit("setTextBubbleText", speechText);
      console.log(getters.getAvatarLangCodes, "These are codes in avatat Talk");
      if (getters.getEnableSpeechRec) {
        window.sayText(
          speechText,
          getters.getAvatarLangCodes.voiceId,
          getters.getAvatarLangCodes.langId,
          getters.getAvatarLangCodes.engineId,
        );
      }
    },

    async requestAI({ getters, commit, dispatch }, transcript) {
      try {
        let lang;
        if (getters.getCurrentLanguage === "en") {
          lang = "english";
        } else if (getters.getCurrentLanguage === "es-US") {
          console.log("lang is spanish");
          lang = "spanish";
        } else {
          lang = "english";
        }

        console.log("Current Language", getters.getCurrentLanguage);
        console.log();
        let data = JSON.stringify({
          question: transcript,
          lang: lang,
          client: "chester",
          type: "inside",
          conversation: getters.getConversationAI,
        });

        console.log(data, "This is data to send to APi for response");

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
          // url:"https://6ws9t7h1-3050.usw3.devtunnels.ms/api/query",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        const response = await axios.request(config);

        const date = new Date();
        dispatch("addSessionDataToStrapi", {
          applicationId: getters.getKioskProfile.data().applicationId,
          actionType: "QnA",
          applicationSessionId: getters.getSessionId,
          timeStamp: date.toISOString(),
          sessionPayload: {
            module: "QnA",
            action: transcript,
            response: response.data,
            timeStamp: date.toISOString(),
          },
        });
        commit("setConversationsAI", {
          question: transcript,
          answer: response.data.answer.response,
        });
        dispatch("addInteractionToPostgres", {
          actionType: "Interaction",
          actionPayload: {
            module: "QnA",
            navigateFrom: "Home",
            navigateTo: "Home",
            interactionType: "Speech",
            elementContent: {
              question: transcript,
              answer: response.data.answer.response,
              response: response.data,
              confidenceScore: 1,
            },
          },
        });

        const processedAnswer = await dispatch(
          "generateAnswerChatBot",
          response.data.answer,
        );
        return {
          text: processedAnswer.response || null,
          helperText: processedAnswer.helperText || null,
        };
      } catch (error) {
        console.error("Error in requestQna1:", error);
        throw error;
      }
    },

    generateAnswerChatBot({ dispatch, commit, getters }, result) {
      // return "Called Properly"
      const intent = result.intent;
      const ansObj = result.response;
      const metadata = result.metadata;
      console.log("This is intent:", intent, "This is answer:", ansObj);
      console.log("This is metadata:", metadata);
      switch (intent) {
        case "speak":
          return ansObj;
        case "showform":
          try {
            console.log("Comming inside showform", ansObj);
            var formName = metadata.formname;
            const linkid = metadata.linkid;
            console.log("requested form link identity", linkid);
            console.log(formName, "this is formName");
            var formReq = i18n
              .t("forms")
              .filter((form) => form.linkId.toString() === linkid);
            console.log(formReq, "required form:");
            if (formReq.length > 0) {
              const form = formReq[0]; // Get the first match
              dispatch("openPdfViewer", {
                url: form.document,
                name: form.formName,
                desc: "Hello There",
                emailLink: form.documentUrl,
                type: form.documentType,
              });

              // return `${i18n.t("qnaResponses.formResponse")} ${form.formName}`;
              // return `${ansObj} ${i18n.t("qnaResponses.formResponse")}`;
              return {
                response: ansObj || null,
                helperText: i18n.t("qnaResponses.formResponse") || null,
              };
            } else {
              // dispatch("defaultMessages");
              // return `${i18n.t("qnaResponses.infoNotFound")}`;
              return {
                response: ansObj || null,
                helperText: i18n.t("qnaResponses.infoNotFound") || null,
              };
            }
          } catch (e) {
            console.log("Catch block Exception in Show Form", e.message);
            // dispatch("defaultMessages");

            return {
              response: ansObj || null,
              helperText: i18n.t("qnaResponses.infoNotFound") || null,
            };
          }
        case "searchbylinkid": {
          const faqReq = i18n
            .t("faqs")
            .filter((faq) => faq.linkId.toString() === metadata.linkid);

          let redirectedFlag = false;

          if (faqReq.length > 0) {
            const faq = faqReq[0];
            console.log("Needed Faq:", faq);
            if (faq.showUrl) {
              if (faq.urlDetails && faq.urlDetails.urllist[0].redirect) {
                redirectedFlag = true;
                if (faq.urlDetails && faq.urlDetails.urllist[0].showpopup) {
                  const message = i18n.t("paymentPopupMsg");
                  commit("setPaymentPopUp", true);
                  // return "" + message;
                  // return `${i18n.t("qnaResponses.payInfo")} ${message}`;
                  return {
                    response: message || null,
                    helperText: i18n.t("qnaResponses.payInfo") || null,
                  };
                } else {
                  window.open(faq.urlDetails.urllist[0].link, "_blank");
                  return {
                    response: faq.urlDetails.urllist[0].link || null,
                    helperText: i18n.t("qnaResponses.redirectInfo") || null,
                  };

                  // return "Opening link: " + faq.urlDetails.urllist[0].link;
                }
              } else if (!redirectedFlag) {
                commit("setQnaKeyword", "");
                router.addRoute({
                  path: "/faqs",
                  component: () => import("@/views/faqs"),
                });

                if (router.currentRoute.path !== "/faqs") {
                  router.push("/faqs");
                }

                const page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === "faqs");
                commit("setPageHeader", page[0].pageType[0].pageHeader);

                const linkId = metadata.linkid;
                // commit("setQnaKeyword", linkId);
                // return `${i18n.t("qnaResponses.faqInfo")} ${faq.question}`;

                return {
                  response: ansObj || null,
                  helperText: i18n.t("qnaResponses.faqInfo") || null,
                };
              }
            } else {
              commit("setQnaKeyword", "");
              router.addRoute({
                path: "/faqs",
                component: () => import("@/views/faqs"),
              });

              if (router.currentRoute.path !== "/faqs") {
                router.push("/faqs");
              }

              const page = i18n
                .t("homepages")
                .filter((page) => page.pageType[0].pathName === "faqs");
              commit("setPageHeader", page[0].pageType[0].pageHeader);

              const linkId = metadata.linkid;
              commit("setQnaKeyword", linkId);

              // return `${i18n.t("qnaResponses.faqInfo")} ${faq.question}`;
              return {
                response: ansObj || null,
                helperText: i18n.t("qnaResponses.faqInfo") || null,
              };
            }
          } else {
            // No FAQ found with this linkId
            // dispatch("defaultMessages");

            return {
              response: ansObj || null,
              helperText: i18n.t("qnaResponses.infoNotFound") || null,
            };
          }
          break;
        }
        case "showmap":
          try {
            var mapPath = i18n
              .t("maps")
              .filter(
                (map) =>
                  map.displayPosition.toString() === metadata.linkid.toString(),
              );

            console.log(mapPath, "Map path filtered out");

            if (mapPath.length > 0) {
              const showFloor =
                getters.getKioskProfile.data().locationCode !== "DHS"
                  ? `${i18n.t("defaultfloor")} - ${mapPath[0].mapFloor + 1}`
                  : `${i18n.t("defaultfloor")} - ${mapPath[0].mapFloor}`;

              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
                floor: showFloor,
              });
              return {
                response: ansObj || null,
                helperText: i18n.t("qnaResponses.mapResponse") || null,
              };
            } else {
              // dispatch("defaultMessages");
              return {
                response: ansObj || null,
                helperText: i18n.t("qnaResponses.infoNotFound") || null,
              };
            }
          } catch (e) {
            console.log("Catch block Exception in showmap", e.message);
            // dispatch("defaultMessages");
            return {
              response: ansObj || null,
              helperText: i18n.t("qnaResponses.infoNotFound") || null,
            };
          }
        // break;

        case "followup":
          console.log(
            "Location Code:",
            getters.getKioskProfile.data().locationCode,
          );
          var followUp = [];
          if (
            getters.getKioskProfile.data().kioskPremise.toLowerCase() ===
            "outside"
          ) {
            i18n
              .t("followupQuestionMDJ")
              .split(",")
              .forEach((item) => followUp.push(item));
          } else {
            if (getters.getKioskProfile.data().locationCode === "DRO") {
              console.log("Coming here in DRO??");
              i18n
                .t("followUpQuestionsDRO")
                .split(",")
                .forEach((item) => followUp.push(item));
            } else if (getters.getKioskProfile.data().locationCode === "DHS") {
              console.log("Coming here in DHS??");
              i18n
                .t("followUpQuestionsDHS")
                .split(",")
                .forEach((item) => followUp.push(item));
            } else {
              console.log("Coming here in JC??");
              i18n
                .t("followupQuestionJC")
                .split(",")
                .forEach((item) => followUp.push(item));
            }
          }

          dispatch("openOptionsViewer", {
            dialogHeader: i18n.t("selectOptionMsg"),
            dialogData: followUp,
          });

          return `${i18n.t("qnaResponses.followUpInfo")}`;
        // break;

        default:
          // For unknown intents, return the response or the intent itself
          return ansObj || `Unhandled intent: ${intent}`;
      }
    },

    requestQnA({ getters, dispatch, commit }, transcript) {
      // Request to QNA
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }

      let lang;
      if (getters.getCurrentLanguage === "en") {
        lang = "english";
      } else if (getters.getCurrentLanguage === "es-US") {
        console.log("lang is spanish");
        lang = "spanish";
      } else {
        lang = "english";
      }

      console.log("Current Language", getters.getCurrentLanguage);
      let data = JSON.stringify({
        question: transcript,
        type: "inside",
        lang: lang,
        client: "chester",
        conversation: [],
      });

      console.log(data, "This is data to send to APi for response");

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      console.log(config, "Configguiration");
      commit("setIsThinking", true);
      if (getters.getCurrentLanguage === "en") {
        commit("setTextBubbleText", "Thinking....");
      } else {
        commit("setTextBubbleText", "Pensando....");
      }

      axios
        .request(config)
        .then((response) => {
          console.log(response.data, "response recived from qna");
          const date = new Date();
          dispatch("addSessionDataToStrapi", {
            applicationId: getters.getKioskProfile.data().applicationId,
            actionType: "QnA",
            applicationSessionId: getters.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "QnA",
              action: transcript,
              response: response.data,
              timeStamp: date.toISOString(),
            },
          });

          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: transcript,
                answer: response.data.answer.response,
                response: response.data,
                confidenceScore: 1,
              },
            },
          });

          dispatch("generateAnswer", response.data);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error, "error is raised here");
        });
    },

    defaultMessages({ dispatch, commit, getters }) {
      if (
        getters.getKioskProfile.data().kioskPremise.toLowerCase() === "outside"
      ) {
        commit("setIsThinking", false);
        commit("setTextBubbleText", i18n.t("outsideError"));
        dispatch("avatarTalk", i18n.t("outsideError"));
      } else {
        if (getters.getKioskProfile.data().locationCode === "PDCAK") {
          dispatch("avatarTalk", i18n.t("kbError"));
        } else if (getters.getKioskProfile.data().locationCode === "DHS") {
          dispatch("avatarTalk", i18n.t("defaultDHSKBError"));

          const mapPath = getters.getMaps.get(
            getters.getDefaultLocation.toLowerCase(),
          );
          console.log(mapPath, " MapPath in ");
          dispatch("openImageViewer", {
            name: mapPath.mapName,
            url: mapPath.mapImage,
            floor: `${i18n.t("defaultfloor")} - ${mapPath.mapFloor}`,
          });
        } else {
          dispatch("avatarTalk", i18n.t("defaultKBError"));
          const mapPath = getters.getMaps.get(
            getters.getDefaultLocation.toLowerCase(),
          );
          console.log(mapPath, " MapPath in ");
          dispatch("openImageViewer", {
            name: mapPath.mapName,
            url: mapPath.mapImage,
            floor: `${i18n.t("defaultfloor")} - ${mapPath.mapFloor + 1}`,
          });
        }
      }
    },

    generateAnswer({ dispatch, commit, getters }, result) {
      if (getters.getIsThinking) {
        console.log("result:", result);
        commit("setQnaStatus", false);
        const intent = result.answer.intent;
        const ansObj = result.answer.response;
        const metadata = result.answer.metadata;
        console.log(metadata, ansObj, "inside generate Answer");
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (intent) {
          case "speak":
            dispatch("avatarTalk", ansObj);
            break;
          case "navigate": {
            var menuName = metadata.path;
            let pageReq = i18n
              .t("homepages")
              .filter((page) => page.pageType[0].pathName === menuName);

            if (pageReq.length > 0) {
              router.addRoute({
                path: menuName.toLowerCase(),
                component: () => import("@/views/" + menuName),
              });
              if (router.currentRoute.path !== menuName) {
                router.push(menuName).then(() => {
                  commit("setQnaKeyword", "");
                  dispatch("avatarTalk", ansObj);
                  commit("setPageHeader", pageReq[0].pageType[0].pageHeader);
                });
              } else {
                commit("setQnaKeyword", "");
                dispatch("avatarTalk", ansObj);
              }
            } else {
              console.log("Navigation Page Not Found");
              dispatch("defaultMessages");
            }
            break;
          }
          case "showmap":
            try {
              var mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.displayPosition.toString() ===
                    metadata.linkid.toString(),
                );

              console.log(mapPath, "Map path filtered out");

              if (mapPath.length > 0) {
                const showFloor =
                  getters.getKioskProfile.data().locationCode !== "DHS"
                    ? `${i18n.t("defaultfloor")} - ${mapPath[0].mapFloor + 1}`
                    : `${i18n.t("defaultfloor")} - ${mapPath[0].mapFloor}`;

                dispatch("openImageViewer", {
                  name: mapPath[0].mapName,
                  url: mapPath[0].mapImage,
                  floor: showFloor,
                });
                dispatch("avatarTalk", mapPath[0].speech);
              } else {
                dispatch("defaultMessages");
              }
            } catch (e) {
              console.log("Catch block Exception in showmap", e.message);
              dispatch("defaultMessages");
            }
            break;
          case "showform":
            try {
              console.log("Comming inside showform", ansObj);
              var formName = metadata.formname;
              const linkid = metadata.linkid;
              console.log("requested form link identity", linkId);

              console.log(formName, "this is formName");

              var formReq = i18n
                .t("forms")
                .filter((form) => form.linkId.toString() === linkid);

              console.log(formReq, "required form:");
              if (formReq.length > 0) {
                const form = formReq[0]; // Get the first match
                dispatch("openPdfViewer", {
                  url: form.document,
                  name: form.formName,
                  desc: "Hello There",
                  emailLink: form.documentUrl,
                  type: form.documentType,
                });
                dispatch("avatarTalk", ansObj);
              } else {
                dispatch("defaultMessages");
              }
            } catch (e) {
              console.log("Catch block Exception in Show Form", e.message);
              dispatch("defaultMessages");
            }
            break;
          case "searchbykeyword":
          case "searchbylinkid": {
            const faqReq = i18n
              .t("faqs")
              .filter((faq) => faq.linkId.toString() === metadata.linkid);

            var redirectedFlag = false;

            if (faqReq.length > 0) {
              const faq = faqReq[0];
              if (faq.urlDetails && faq.urlDetails.urllist[0].redirect) {
                redirectedFlag = true;
                // console.log(
                //   metadata.showpopup,
                //   "if this value is true show popUp."
                // );
                if (faq.urlDetails && faq.urlDetails.urllist[0].showpopup) {
                  const message = i18n.t("paymentPopupMsg");
                  commit("setPaymentPopUp", true);
                  commit("setIsThinking", false);
                  commit("setTextBubbleText", message);
                  dispatch("avatarTalk", message);
                } else {
                  console.log("Redirecting to Chester website:", faq);
                  // dispatch("kioskRedirected");
                  // commit("setIsSpeaking", false)
                  commit("setIsThinking", false);
                  commit("setTextBubbleText", i18n.t("bubbletextafteraction"));

                  // window.location.href = faq.urlDetails.urllist[0].link;
                  window.open(faq.urlDetails.urllist[0].link, "_blank");
                }
                break;
              } else if (!redirectedFlag) {
                commit("setQnaKeyword", "");
                router.addRoute({
                  path: "/faqs",
                  component: () => import("@/views/faqs"),
                });
                if (router.currentRoute.path !== "/faqs") {
                  router.push("/faqs");
                }
                var page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === "faqs");
                commit("setPageHeader", page[0].pageType[0].pageHeader);
                var linkId = metadata.linkid;
                commit("setQnaKeyword", linkId);
                dispatch("avatarTalk", ansObj);
              } else {
                dispatch("defaultMessages");
              }
              break;
            } else {
              dispatch("defaultMessages");
            }

            break;
          }
          case "showfaqcategory":
            // commit("setQnaKeyword", "")
            // var faqKeyword = ansObj.metadata.keyword

            // router.addRoute({ path: '/faqs', component: () => import('@/views/faqs') })
            // if (router.currentRoute.path !== '/faqs') {
            //     router.push('/faqs')
            // }
            // var page = i18n.t('homepages').filter(page => page.pageType[0].pathName === 'faqs')
            // commit('setPageHeader', page[0].pageType[0].pageHeader)
            // var count = i18n.t('faqCategory').filter(cat => cat.categoryName.toLowerCase() === faqKeyword)
            // if (count.length === 0) {
            //     var englishFaqList = getters.getFaqs.filter(faq => faq.locale === 'en')
            //     var linkId = englishFaqList.filter(faq => faq.question.toLowerCase().includes(faqKeyword))
            //     if (linkId.length > 0) {
            //         commit("setQnaKeyword", linkId[0].linkId)
            //     } else {
            //         mapPath = getters.getMaps.get(getters.getDefaultLocation.toLowerCase())
            //         dispatch('openImageViewer', {
            //             name: mapPath.mapName,
            //             url: mapPath.mapImage
            //         })
            //         dispatch('avatarSpeak', i18n.t('kbError'))
            //     }

            // } else {

            //     commit('setSelectedFaqCat', { name: faqKeyword, type: 'expansionPanel' })
            // }
            // dispatch('avatarSpeak', ansObj.answer);
            break;

          case "showformcategory":
            var formKeyword = ansObj.metadata.keyword;
            router.addRoute({
              path: "/forms",
              component: () => import("@/views/forms"),
            });
            if (router.currentRoute.path !== "/forms") {
              router.push("/forms");
            }
            commit("setPageHeader", "Forms");
            commit("setQnaKeyword", formKeyword);
            dispatch("avatarTalk", ansObj.answer);
            break;

          case "showformpackets":
            var packetInfo = getters.getFormPacketsEnglish.get(
              ansObj.metadata.find(({ name }) => name === "keyword").value,
            );
            dispatch("openPdfViewer", {
              url: packetInfo.packetFiles,
              name: packetInfo.packetName,
              desc: packetInfo.packetDesc,
              emailLink: packetInfo.packetLink,
              type: "Packet",
            });
            //dispatch('avatarSpeak', ansObj.answer);
            break;

          case "showhours":
            dispatch("openCourtTimingViewer", {});
            dispatch("avatarTalk", ansObj.answer);

            break;

          case "session":
            var action = ansObj.metadata.find(
              ({ name }) => name === "action",
            ).value;
            if (action === "still there") {
              dispatch("kioskStillThere");
            } else {
              dispatch("resetKiosk");
            }
            break;

          case "redirect":
            console.log("Redirect To external website from here after speech.");
            break;

          case "followup":
            var followUp = [];
            if (
              getters.getKioskProfile.data().kioskPremise.toLowerCase() ===
              "outside"
            ) {
              i18n
                .t("followupQuestionMDJ")
                .split(",")
                .forEach((item) => followUp.push(item));
            } else {
              if (getters.getKioskProfile.data().locationCode === "DRO") {
                i18n
                  .t("followUpQuestionsDRO")
                  .split(",")
                  .forEach((item) => followUp.push(item));
              } else if (
                getters.getKioskProfile.data().locationCode === "DHS"
              ) {
                console.log("Coming here in DHS??");
                i18n
                  .t("followUpQuestionsDHS")
                  .split(",")
                  .forEach((item) => followUp.push(item));
              } else {
                i18n
                  .t("followupQuestionJC")
                  .split(",")
                  .forEach((item) => followUp.push(item));
              }
            }

            dispatch("avatarTalk", ansObj);

            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followUp,
            });

            break;

          case "fallback":
          default:
            dispatch("defaultMessages");
            break;
        }
        console.log("Intent not found.");
      }
    },
  },
};
